import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/** The raised-hand marker shown next to the name in the participants-panel row. */
export function HandBadge({ identity }: { readonly identity: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`hand-badge-${identity}`}
      title={t('participants.hand_title')}
      aria-label={t('participants.hand_aria')}
      className="shrink-0 text-[13px] leading-none"
    >
      ✋
    </span>
  );
}
